import { createFileRoute } from '@tanstack/react-router';
import ResetPasswordPage from '@/pages/reset-password/index.page';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/reset_password/')({
  component: withRumPageRendered(ResetPasswordPage),
});
